<template>
  <h1 class="text-primary-600 text-2xl! font-normal!">
    <slot name="default" />
  </h1>
</template>

<script setup lang="ts">
  interface Slots {
    /**
     * Heading Content
     */
    default(): never
  }

  defineSlots<Slots>()
</script>
